/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Membership_Page_TitleInputs */

const fr_membership_page_title = /** @type {(inputs: Membership_Page_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mon abonnement`)
};

/**

* @param {Membership_Page_TitleInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const membership_page_title = /** @type {((inputs?: Membership_Page_TitleInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Membership_Page_TitleInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_membership_page_title(inputs)
});